<template>
    <div class="page-home">
        <!--            banner-->

        <div class="banner">
            <div class="wp">
                <div class="banner-swiper">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide cursorPointer" @click="bannerClick(item)" v-for="(item,index) in bannerList" :key="index">
                            <img :src="item.pictureUrl" alt="">
<!--                            fill / contain / cover / none / scale-down-->
<!--                            <el-image style="height: 342px;width: 100%" :src="item.pictureUrl" fit="fill"></el-image>-->
                        </div>
<!--						<div class="swiper-slide"><img src="@/assets/img/home-ban.png" alt=""></div>-->
                    </div>
                </div>
            </div>
        </div>
        <!--            产品资讯-->
        <section class="sec-swiper">
            <div class="wp">
                <div class="g-title">
                    <img src="@/assets/img/g-tit1.png" alt="">
                </div>
                <div class="product-swiper">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide cursorPointer" @click="goCPdetail(item)" v-for="(item,index) in cpList" :key="index">
                            <div class="con">
                                <div class="inner">
                                    <div class="pic">
                                        <img :src="item.pictureUrl || defaultImg" alt="">
                                    </div>
                                    <div class="title">{{item.title}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="swiper-button-next"></div>
                    <div class="swiper-button-prev"></div>
                </div>
            </div>
        </section>
        <!--            推荐品牌-->
        <section class="sec-brand">
            <div class="wp">
                <div class="g-title">
                    <img src="@/assets/img/g-tit2.png" alt="">
                </div>
                <div class="brand-list">
                    <div @click="goPPdetail(item)" class="item" v-for="(item,index) in brandList" :key="index">
                        <div class="pic">
                            <img :src="item.logoUrl" alt="">
                        </div>
                        <div class="text">
                            <div class="title"><span>{{ item.name }}</span></div>
                            <div class="btn cursorPointer">进入品牌专场 <img src="@/assets/img/i-arr.png" alt=""></div>
                        </div>
                    </div>
                </div>
                <a href="#/Brand" class="btn-more">查看更多></a>
            </div>
        </section>
        <!--            新闻资讯-->
        <section>
            <div class="wp">
                <div class="g-title">
                    <img src="@/assets/img/g-tit3.png" alt="">
                </div>
                <div class="news-layout">
                    <div class="left">
                        <div class="news-item cursorPointer" @click="goNewdetail(Newstop)">
                            <div class="pic" style="max-width: 214px !important;width: inherit;">
                                <img :src="Newstop.pictureUrl" alt="">
                            </div>
                            <div class="text wid70">
                                <div class="newtitle">{{ Newstop.title }}</div>
                                <div class="text_hidden2">
                                    <p v-html="`${Newstop.introduce}`"></p>
                                </div>
<!--                                <p>后疫情时代，加拿大的很多企业都出现了用工荒，空缺职位甚至超过了疫情前的水...</p>-->
                                <span>{{ Newstop.updateTime }}</span>
                            </div>
                        </div>
                        <div class="list">
                            <div @click="goNewdetail(item)" class="item cursorPointer mab20" v-for="(item,index) in NewsList" :key="index">
                                <div class="newtitle">{{ item.title }}</div>
                                <div class="text_hidden2" v-html="`${item.introduce}`"></div>
                            </div>
                        </div>
                        <a href="#/News" class="more">查看更多></a>
                    </div>
                    <div class="right">
                        <div class="title">
                            <h3>技术资料
                                <img src="@/assets/img/i-arr2.png" alt="">
                            </h3>
                            <a href="#/TechInfo">查看更多></a>
                        </div>
                        <div class="list">
                            <div class="item cursorPointer" @click="goTechnicadetail(item)" v-for="(item,index) in TechnicaList" :key="index">
                                <div class="fts16 c-333 ftwt text_hidden1 wid65">{{ item.title }}</div>
                                <span style="margin-left: 15px">{{item.publishTime}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!--            标语-->
        <section class="sec-text">
            <div class="wp">
                <div class="home-row">
                    <div class="item">
                        <img src="@/assets/img/row-i1.png" alt="">
                        <h3>透明比价</h3>
                        <p>Transparent price comparison</p>
                    </div>
                    <div class="item">
                        <img src="@/assets/img/row-i2.png" alt="">
                        <h3>质量保证</h3>
                        <p>Quality assurance</p>
                    </div>
                    <div class="item">
                        <img src="@/assets/img/row-i3.png" alt="">
                        <h3>身边的采购管家</h3>
                        <p>Purchasing the housekeepe</p>
                    </div>
                </div>
            </div>
        </section>
        <!--            推荐产品-->
        <section class="sec-product">
            <div class="wp">
                <div class="g-title2">
                    <h3>
                        <span>推荐</span>产品
                    </h3>
                </div>
                <productRow :textData="row1" />
                <productRow :textData="row2"/>
                <productRow :textData="row3"/>
                <productRow :textData="row4"/>

            </div>
        </section>
        <!--            标语2-->
        <div class="home-row2">
            <img src="@/assets/img/row-bg2.png" alt="" class="bg">
            <div class="wp">
                <div class="item">
                    <div class="pic">
                        <img src="@/assets/img/row2-i1.png" alt="">
                    </div>
                    <p>品类齐全 应有尽有</p>
                </div>
                <div class="item">
                    <div class="pic">
                        <img src="@/assets/img/row2-i2.png" alt="">
                    </div>
                    <p>多仓直发 极速配送</p>
                </div>
                <div class="item">
                    <div class="pic">
                        <img src="@/assets/img/row2-i3.png" alt="">
                    </div>
                    <p>正品行货 品质保证</p>
                </div>
                <div class="item">
                    <div class="pic">
                        <img src="@/assets/img/row2-i4.png" alt="">
                    </div>
                    <p>轻松购物 畅选无忧</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import pageCommonHeader from "@/components/page-common-header.vue";
import "swiper/dist/css/swiper.min.css";
import Swiper from "swiper";
import productRow from "@/components/product-row.vue";

import {
    slideshowList,productPage,brandinfoPage,articleNewspageList,articleTechnicalPage,
    goodsTypeList,
	goodsInfoHotPage,
} from "@/api/home"


export default {
    data: function () {
        return {
            row1: {
                bg: require('@/assets/img/row1-bg.png'),
                color: 'rgba(227,106,19,.9)',
                color2: 'rgba(227,106,19,1)',
                title: '标准品',
                p: 'PanphyⓇ标准品',
                span: '随货附带信息详尽的COA',
                bigBg: require('@/assets/img/p1-bg.png'),
                bigTit: require('@/assets/img/p1-tit.png'),
            },
            row2: {
                bg: require('@/assets/img/row2-bg.png'),
                color: 'rgba(52, 150, 168, .9)',
                color2: 'rgba(52, 150, 168, 1)',
                title: '试剂',
                p: 'EMSURE®',
                span: '试剂行业金标准',
                bigBg: require('@/assets/img/p2-bg.png'),
                bigTit: require('@/assets/img/p2-tit.png'),
            },
            row3: {
                bg: require('@/assets/img/row3-bg.png'),
                color: 'rgba(51,106,194, .9)',
                color2: 'rgba(51,106,194, 1)',
                title: '耗材仪器',
                p: '固相萃取',
                span: '最有用的样品前处理技术',
                bigBg: require('@/assets/img/p3-bg.png'),
                bigTit: require('@/assets/img/p3-tit.png'),
            },
            row4: {
                bg: require('@/assets/img/row4-bg.png'),
                color: 'rgba(229,144,53, .9)',
                color2: 'rgba(229,144,53, 1)',
                title: '生物用品',
                p: '颗粒培养基',
                span: '培养基行业发展的新趋势',
                bigBg: require('@/assets/img/p4-bg.png'),
                bigTit: require('@/assets/img/p4-tit.png'),
            },

            bannerList:[],
            cpList:[], // 产品资讯
			brandList:[],//推荐品牌
            NewsList:[], // 新闻列表
            Newstop:"", //置顶新闻
            TechnicaList:[], //技术资料
            linkList:[], // 友情链接




        }
    },
    name: 'home',
    components: {
        pageCommonHeader, productRow
    },
    created() {
        this.getslideshowList() // 获取轮播图

    },
    mounted() {
        this.getbrandinfoPage() //品牌列表
        this.getarticleNewspageList() //新闻资讯
        this.getarticleTechnicalList() //技术资料
        this.getgoodsTypeList('标准品') // 推荐分类id
        this.getgoodsTypeList('试剂') // 推荐分类id
        this.getgoodsTypeList('耗材仪器') // 推荐分类id
        this.getgoodsTypeList('生物用品') // 推荐分类id

    },
    methods: {
        // 初始化swiper
        initSwiper: function () {
            // var that = this;
            this.$nextTick(function(){
                var swiper = new Swiper('.banner-swiper', {
                    // loop: true,
                    autoplay: {
                        delay: 5000
                    }
                });
                var swiper2 = new Swiper('.product-swiper', {
                    // loop: true, // 首尾相接
                    navigation: {
                        nextEl: ' .swiper-button-next',
                        prevEl: ' .swiper-button-prev',
                    },
                    autoplay: {//设置为true启动自动切换，并使用默认的切换设置。
                        delay: 3000
                    },
                    slidesPerView: 5, //设置slider容器能够同时显示的slides数量(carousel模式)。
                    spaceBetween: 11,
                    breakpoints: {
                        767: {  //当屏幕宽度大于等于320
                            slidesPerView: 1,
                            spaceBetween: 10
                        },
                        959: {  //当屏幕宽度大于等于768
                            slidesPerView: 1,
                            spaceBetween: 20
                        },
                    },

                });
            })

        },
        bannerClick(item){
            console.log(item)
            // 链接类型：1 新闻中心详情页 2 产品咨询详情页 3 商品详情页 4 其他链接 5品牌中心
            if(item.linkType==1){
                this.$router.push({path:'/NewsDetail',query: {id:item.routeUrl}}) //
            }else if(item.linkType==2){
                this.$router.push({path:'/ProductInfoDetail',query: {id:item.routeUrl}}) //
            }else if(item.linkType==3){
                this.$router.push({path:'/ProductDetail',query: {id:item.routeUrl}}) //
            }else if(item.linkType==4){
                window.open(item.routeUrl)
            }else if(item.linkType==5){
                this.$router.push({path:'/BrandDetail',query: {id:item.routeUrl}}) //
            }
        },
        goCPdetail(item){
            this.$router.push({path:'/ProductInfoDetail',query: {id:item.id}})
        },
		goPPdetail(item){
            // query传参数跳转用path (/BrandDetail类似get,url后面会显示参数) params传参数跳转用name (类似post)
			this.$router.push({path:'/BrandDetail',query: {id:item.id}}) //
		},
        goNewdetail(item){
            // query传参数跳转用path (/BrandDetail类似get,url后面会显示参数) params传参数跳转用name (类似post)
            this.$router.push({path:'/NewsDetail',query: {id:item.id}}) //
        },
        goTechnicadetail(item){
            this.$router.push({path:'/TechInfoDet',query: {id:item.id}}) //
        },


        //  -------------------------接口请求
        getslideshowList(){ // 获取轮播图 position 0首页，1积分商城  status:1显示
            slideshowList({position:0,status:1}).then((res) => {
                if (res.data.code==200) {
                    this.bannerList=res.data.data.records
                    this.getproductList() // 获取产品资讯
                }
            })
        },
        getproductList(){ // 获取产品资讯
            let param={
                size:10,
                current:1,
                isTop:1
            }
            productPage(param).then((res) => {
                if (res.data.code==200) {
                    this.cpList=res.data.data.records
                    this.initSwiper() // 创建轮播图
                }

            })
        },
        getbrandinfoPage(){ // 获取品牌列表
            let param={
                size:14,
                current:1,
				isHot:1
            }
            brandinfoPage(param).then((res) => { // isHot=1表示推荐
				if (res.data.code==200) {
					this.brandList=res.data.data.records
				}

			})
		},
        // 获取新闻资讯
        getarticleNewspageList(){
            let param={
                size:9,
                current:1,
                isTop:1
            }
			articleNewspageList(param).then((res) => { // isTop=1表示推荐置顶
                if (res.data.code==200) {
                    this.NewsList=[]
                    res.data.data.records.forEach((i,index)=>{
                        i.contentText1=i.contentText
                        i.contentText=this.$utils.showHtml(i.contentText)
                        i.contentText=i.contentText.replace(/\u3000/g, "")  // 替换空格符
                        // let informationArticle = informationArticle.replace(/<\/?(img)[^>]*>/gi, ''); // 去除富文本中的图片
                        // if(i.isTop==1){
                        if(index==0){
                            this.Newstop=i
                        }else{
                            this.NewsList.push(i)
                        }
                    })

                }

            })
        },
        getarticleTechnicalList(){
            let param={
                size:7,
                current:1,
                isTop:1
            }
            articleTechnicalPage(param).then((res) => { // isTop=1表示推荐
                if (res.data.code==200) {
                    res.data.data.records.forEach((i,index)=>{
                        i.contentText1=i.contentText
                        i.contentText=this.$utils.showHtml(i.contentText)
                        i.contentText=i.contentText.replace(/\u3000/g, "")  // 替换空格符
                        i.publishTime=this.$utils.formatDate(i.publishTime,'yyyy-mm-dd')

                    })
                    this.TechnicaList=res.data.data.records

                }

            })
        },
        getgoodsTypeList(name){
            goodsTypeList({name:name}).then((res) => {
                if (res.data.code==200) {
                    if(res.data.data[0]){
                        this.getgoodsInfoList(name,res.data.data[0].id)

                    }
                }

            })
        },
        getgoodsInfoList(name,id){ // 查询分类下推荐产品
            let param={
                size:8,
                current:1,
                isHot:1,
                goodsTypeIds:id
            }
	        goodsInfoHotPage(param).then((res) => {
                if (res.data.code==200) {
                    if(name=='标准品'){
                        this.row1={...this.row1, ...{id:id,goodslist:res.data.data.records}}
                        console.log(this.row1)
                    }
                    if(name=='试剂'){
                        this.row2={...this.row2, ...{id:id,goodslist:res.data.data.records}}
                        console.log(this.row2)
                    }
                    if(name=='耗材仪器'){
                        this.row3={...this.row3, ...{id:id,goodslist:res.data.data.records}}
                        console.log(this.row3)
                    }
                    if(name=='生物用品'){
                        this.row4={...this.row4, ...{id:id,goodslist:res.data.data.records}}
                        console.log(this.row4)
                    }
                }

            })
        },


    }
}
</script>

<style>
.page-home .newtitle{
    display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #333333;
    font-size: 20px;
    font-weight: bold;
}

</style>
